import { useTranslation } from "react-i18next";
import { Card, CardBody, CardTitle } from "react-bootstrap";

function TimeLine({ data, page, type = "all" }) {
  const { t } = useTranslation(); // Use t instead of lang
const isDecimal = (num) => typeof num === "number" && num % 1 !== 0;

const list = [
  {
    id: "0",
    title: "Sum of Total",
    value: page === "Orders" ? data?.TotalPriceForAllOrder : data?.TotalPrice,
    isDecimal: isDecimal(page === "Orders" ? data?.TotalPriceForAllOrder : data?.TotalPrice),
    state: "1",
    type: ["all", "itemOrder", "driver", "store"],
  },
  {
    id: "1",
    title: "Total with Profit",
    value:
      page === "Orders"
        ? data?.TotalPriceWithProfitForAllOrder
        : data?.TotalPriceWithProfit,
    isDecimal: isDecimal(
      page === "Orders"
        ? data?.TotalPriceWithProfitForAllOrder
        : data?.TotalPriceWithProfit
    ),
    state: "2",
    type: ["all", "itemOrder", "driver", "store"],
  },
  {
    id: "2",
    title: "Tax",
    value: page === "Orders" ? data?.TotalTaxFeeForAllOrder : data?.TaxFee,
    isDecimal: isDecimal(page === "Orders" ? data?.TotalTaxFeeForAllOrder : data?.TaxFee),
    state: "1",
    type: ["all", "itemOrder", "driver", "store"],
  },
  {
    id: "3",
    title: "Delivery Fees",
    value:
      page === "Orders"
        ? data?.TotalDeliveryFeesForAllOrder
        : data?.DeliveryFees,
    isDecimal: isDecimal(
      page === "Orders"
        ? data?.TotalDeliveryFeesForAllOrder
        : data?.DeliveryFees
    ),
    state: "3",
    type: ["all", "itemOrder", "driver", "store"],
  },
  {
    id: "4",
    title: "Number of unpaid Orders",
    value: (type === 'driver' ? data?.NumberOfNotPaidDriverOrders : data?.NumberOfNotPaidOrders),
    isDecimal: isDecimal(data?.NumberOfNotPaidOrders),
    state: "1",
    type: ["all", "driver", "store"],
  },
  {
    id: "5",
    title: "Total Company Profit",
    value: data?.TotalCompanyProfitForAllOrder,
    isDecimal: isDecimal(data?.TotalCompanyProfitForAllOrder),
    state: "2",
    type: ["all", "driver"],
  },
];


  return (
    <Card className="card-custome border-0 rounded-24 my-4">
      <CardBody className="py-5 px-4">
      {list
  .filter((item) => 
    type === "all" 
      ? !item.type.includes("driver") && !item.type.includes("store") // استثناء العناصر
      : item.type.includes(type) // فلترة حسب النوع العادي
  )
  .map((item, index) => (
    <div key={index} className="flex-gap-2 time-line-style before align-items-start">
      <div className="circle-border">
        <div
          className={`circle ${
            item.state === "1"
              ? "bg-primary"
              : item.state === "2"
              ? "bg-warning"
              : "bg-success"
          } `}
        ></div>
      </div>
      <div className="time-line-content">
        <Card.Text className="mb-2 fw-light">
          {t(item.title)} :
        </Card.Text>
        <CardTitle className="fw-bold mb-0">
          $ {item.isDecimal ? item.value.toFixed(2) : item.value}
        </CardTitle>
      </div>
    </div>
  ))}

      </CardBody>
    </Card>
  );
}

export default TimeLine;
